import React from 'react';

import { ReactNodeViewContentProvider } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { renderToReactElement } from '@tiptap/static-renderer';

import type { RecursiveValue } from '../interfaces';
import AnalyticsWrapper from './AnalyticsWrapper';
import SectionBlock, { SectionBlockNodeExtention } from './SectionBlock';

const RenderTiptapContent = ({
  config,
  contentBlock,
}: {
  config: Record<string, RecursiveValue>;
  contentBlock: Record<string, RecursiveValue>;
}) => {
  return (
    <AnalyticsWrapper
      shouldTrackClick={config?.should_track_click as boolean}
      shouldTrackImpression={config?.impression_tracking as boolean}
      trackingLocation={config?.analytics_location as string}
    >
      {renderToReactElement({
        content: contentBlock,
        extensions: [StarterKit, SectionBlockNodeExtention],
        options: {
          nodeMapping: {
            section: ({ children }) => {
              return (
                <ReactNodeViewContentProvider content={children}>
                  <SectionBlock />
                </ReactNodeViewContentProvider>
              );
            },
          },
          unhandledNode: ({ node }) => {
            return `[unknown node ${node.type.name}]`;
          },
          unhandledMark: ({ mark }) => {
            return `[unknown node ${mark.type.name}]`;
          },
        },
      })}
    </AnalyticsWrapper>
  );
};

export default RenderTiptapContent;
